module.exports = __webpack_public_path__ + "static/DonaAlt-Regular-f77cd7f3d18f0fa056ae0de90a93e4a4.eot";